const {
  enumerateWildcardPath,
  mutateContentValue,
  getContentValue
} = require('@truqc/content-path');
const filterObject = (object, wildcardPath, optionPath, optionIdentifier) => {
  const result = JSON.parse(JSON.stringify(object));
  enumerateWildcardPath(object, wildcardPath, (path, value) => {
    if (value !== undefined) {
      const option = getContentValue(optionPath, value) || {};
      const [testIdentifier] = Object.keys(option);
      if (testIdentifier !== optionIdentifier) {
        mutateContentValue(path, result, null);
      }
    }
  });
  return result;
};
module.exports = {
  filterObject
};